export function convertToBoolean(
  value?: boolean | string | null | number | string[],
): boolean {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (Array.isArray(value)) {
    return false;
  }

  const stringValue = String(value).toLowerCase();

  return stringValue === "true" || stringValue === "1";
}
